import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Help from '../views/Help.vue'
import CreateData from '../views/CreateData.vue'
import DataList from '../views/DataList.vue'
import MapList2 from '../views/MapList2.vue'
import Map from '../views/Map.vue'
import Data from '../views/Data.vue'
import Issues from '../views/Issues.vue'
import PageNotFound from '../views/PageNotFound.vue'
import Poster from '../views/Poster.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/about',
    name: 'about',
    component: About
  },
  {
    path: '/help',
    name: 'help',
    component: Help
  },
  {
    path: '/create',
    name: 'create',
    component: CreateData
  },
  {
    path: '/data',
    name: 'data',
    component: DataList
  },
  {
    path: '/data/:dataId',
    name: 'dataDetail',
    component: Data
  },
  {
    path: '/maps',
    name: 'maps',
    component: MapList2
  },
  {
    path: '/maps/:mapId',
    name: 'mapDetail',
    component: Map
  },
  {
    path: '/issues',
    name: 'issues',
    component: Issues
  },
  {
    path: '/poster',
    name: 'poster',
    component: Poster
  },
  {
    path: '/404',
    name: '404',
    component: PageNotFound
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
